module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id=\'details-accordion\'></div>\n<div id=\'invoicing-accordion\'></div>\n<div id=\'companies-accordion\'></div>\n<div id=\'allocations-accordion\'></div>\n<div id=\'system-info-accordion\'></div>\n';

}
return __p
}